import { render, staticRenderFns } from "./shopUserModal.vue?vue&type=template&id=4e786e85&scoped=true"
import script from "./shopUserModal.vue?vue&type=script&lang=js"
export * from "./shopUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e786e85",
  null
  
)

export default component.exports